import { Component, OnInit } from '@angular/core';
import { CoverIndexService } from '../../services/coverindex.service';
import { ActivatedRoute } from '@angular/router';
import { Sharedservice } from './../../shared-components/shared.service';
import { MessageService } from 'primeng/api';
import { UnBrandingModel } from '../../models/unbranding.model';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { ValidationModel } from '../../models/validation.model';
import { ValidationsService } from '../../services/validations.service';
import { severitymessage, ValidationsComponentmessage, LanguageConstants } from '../../shared-components/constant';
import { saveAs } from 'file-saver';
import { EngagementService } from 'src/app/services/engagement.service';
import { InfraService } from 'src/app/services/infra.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-validations',
  templateUrl: './validations.component.html',
  styleUrls: ['./validations.component.css']
})
export class ValidationsComponent implements OnInit {
  engagementId = +this.route.snapshot.paramMap.get('id');
  data: ValidationModel[] = [];
  unbranddata: UnBrandingModel[] = [];
  checked: boolean;
  checkunBrand: boolean;
  checkedval: boolean;
  ischecked: boolean;
  FeatureValidationId: any[] = [];
  FeatureUnbrandingId: any[] = [];
  selectedAll: any;
  loadspinner = false;
  unbrandedDatatbookGenerateURL: string;
  fmLogFileName = '';
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  private configUrl = '';
  private configUrlPython = '';
  currLangTranslation: any;
  langCode: string;

  constructor(private infraService: InfraService, private coverIndexService: CoverIndexService, private messageService: MessageService,
    private route: ActivatedRoute, private sharedService: Sharedservice, private DataBookService: ValidationsService,
    private engagementservice: EngagementService, private translateService: TranslateService) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1;
    });
  }

  ngOnInit() {
    this.messageService.clear('myKey1');
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
    });
    this.getFeaturesValidation();
    this.getFeaturesUnbranding();
  }

  updateCoverIndex() {
    const engBody = {
      engagementName: this.sharedService.activeEngagementName,
      paceId: this.sharedService.activePaceId
    };
    this.coverIndexService.updateCoverIndex(this.engagementId, engBody).subscribe(data => {
    }, error => { }
    );
  }

  getFeaturesValidation(): void {
    this.DataBookService.getFeaturesValidation(this.engagementId).subscribe((data: ValidationModel[]) => {
      this.data = data;
      this.data.filter(w => w.IsSaved === true).forEach(element => {
        this.FeatureValidationId.push({ FeatureValidationId: element.Id, IsSaved: element.IsSaved });
      });
      this.data.filter((r) => {
        return r.IsSaved === true;
      }).map((o) => {
        o.checkedval = true;
      });
    });
  }

  getFeaturesUnbranding(): void {
    this.DataBookService.getFeaturesUnbranding(this.engagementId).subscribe((unbranddata: UnBrandingModel[]) => {
      this.unbranddata = unbranddata;
      this.unbranddata.filter(w => w.IsSaved === true).forEach(element => {
        this.FeatureUnbrandingId.push({ FeatureUnbrandingId: element.Id, IsSaved: element.IsSaved });
      });
      this.unbranddata.filter((r) => {
        return r.IsSaved === true;
      }).map((o) => {
        o.checkunBrand = true;
      });
    });
  }

  checkAll(event) {
    this.FeatureValidationId = [];
    const selected = event.currentTarget.checked;
    if (event.currentTarget.checked) {
      this.data.filter((r) => {
        this.FeatureValidationId.push({ FeatureValidationId: r.Id });
        r.checkedval = selected;
      });
    } else {
      this.data.filter((r) => {
        const index = this.FeatureValidationId.findIndex(x => x.FeatureValidationId === r.Id);
        this.FeatureValidationId.splice(index, 1);
        r.checkedval = selected;
      });
    }
  }

  checkAllUnBrand(event) {
    this.FeatureUnbrandingId = [];
    const selected = event.currentTarget.checked;
    if (event.currentTarget.checked) {
      this.unbranddata.filter((r) => {
        this.FeatureUnbrandingId.push({ FeatureUnbrandingId: r.Id });
        r.checkunBrand = selected;
      });
    } else {
      this.unbranddata.filter((r) => {
        const index = this.FeatureUnbrandingId.findIndex(x => x.FeatureUnbrandingId === r.Id);
        this.FeatureUnbrandingId.splice(index, 1);
        r.checkunBrand = selected;
      });
    }
  }

  checksub(data: any, event: any) {
    if (event.target.checked) {
      this.FeatureValidationId.push({ FeatureValidationId: data.Id });
    } else {
      const index = this.FeatureValidationId.findIndex(x => x.FeatureValidationId === data.Id);
      this.FeatureValidationId.splice(index, 1);
    }
  }

  checksubunbrand(data: any, event: any) {
    if (event.target.checked) {
      this.FeatureUnbrandingId.push({ FeatureUnbrandingId: data.Id });
    } else {
      const index = this.FeatureUnbrandingId.findIndex(x => x.FeatureUnbrandingId === data.Id);
      this.FeatureUnbrandingId.splice(index, 1);
    }
  }

  // Save Logic For Formula Validation
  saveFormulaValidation() {
    let saveValidationData;
    saveValidationData = {
      EngagementId: this.engagementId,
      FeatureValidations: this.FeatureValidationId
    };

    if (this.FeatureValidationId.length !== 0) {
      this.loadspinner = true;

      this.DataBookService.createEngagementFeaturesValidation(saveValidationData).subscribe((response: any) => {
        if (response.message === severitymessage.success) {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
            summary: '', detail: ValidationsComponentmessage.SuccessMessage.SaveValidation, sticky: true, closable: true
          });

          this.engagementservice.getEngagement(this.engagementId).subscribe((data) => {
            if (data !== null) {
              this.fmLogFileName = data.EngagementName;
              const today = new Date();
              this.fmLogFileName += '_DATABOOK_' + `${today.getDate()}${today.getMonth() + 1}${today.getFullYear()}
              _FormulaValidationLog.xlsx`;

              this.DataBookService.processFormulaValidations(this.engagementId)
                .subscribe(
                  blobData => {
                    this.loadspinner = false;
                    if (blobData && blobData.size > 0) {
                      saveAs(blobData, this.fmLogFileName);
                    } else {
                      this.loadspinner = false;
                      this.messageService.add({
                        key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
                        summary: this.currLangTranslation.severitymessage.notification, detail: ValidationsComponentmessage.SuccessMessage.FormulaValidation,
                        sticky: true, closable: true
                      });
                    }
                  },
                  err => {
                    this.loadspinner = false;
                    this.messageService.add({
                      key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
                      summary: this.currLangTranslation.severitymessage.notification,
                      detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
                    });
                  }
                );
            } else {
              this.loadspinner = false;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
              });
            }
          });
        } else {
          this.loadspinner = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: '', detail: this.currLangTranslation.severitymessage.
              somethingwrong, sticky: true, closable: true
          });
        }
      },
        error => {
          this.loadspinner = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: '', detail: error.error.message,
            sticky: true, closable: true
          });
        }
      );
    } else {
      this.loadspinner = false;
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = ValidationsComponentmessage.ErrorMessage.FormulaSelectionError;
    }
  }

  Downloadclick() {
    window.location.href = this.configUrl + 'filedownload/UnbrandeddataBook/' + this.engagementId;
  }

  DownloadFormulaValidationLogFile(filename: string) {
    window.location.href = this.configUrlPython + 'downloadformulavalidationfile/' + encodeURI(filename);
  }

  saveUnBrandingData(event: any) {
    let saveUnbrandingData;
    saveUnbrandingData = {
      EngagementId: this.engagementId,
      FeatureUnbrandings: this.FeatureUnbrandingId
    };
    if (this.FeatureUnbrandingId.length !== 0) {
      this.DataBookService.createEngagementFeaturesUnbranding(saveUnbrandingData).subscribe((response: any) => {
        if (response.message === severitymessage.success) {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
            summary: '', detail: ValidationsComponentmessage.SuccessMessage.UnbrandingSave, sticky: true, closable: true
          });

          this.loadspinner = true;
          this.DataBookService.processUnbrandingfile(this.engagementId).subscribe((response: any) => {
            this.loadspinner = false;
            if (response.status === 'Success') {
              this.Downloadclick();
            } else {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary:
                  'Error while generating unbranded databook.', detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
              });
            }
          }, error => {
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary:
                'Error while generating unbranded databook.', detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
            });
            this.loadspinner = false;
          });
        } else {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: '', detail: this.currLangTranslation.severitymessage.
              somethingwrong, sticky: true, closable: true
          });
        }
      },
        error => {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: '', detail: error.error.message,
            sticky: true, closable: true
          });
        }
      );
    } else {
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = ValidationsComponentmessage.ErrorMessage.BrandingError;
    }
  }

  confirmdisplay = false;
  closeEventPreview(event: any) {
    this.confirmdisplay = event;
  }

  okEventpreview(event: any) {
    this.confirmdisplay = false;
  }
}
